// NOTE: All methods returns void because product decided to get rid of segment tracking
// However, we made this wrapper to enable the tracking again easily even if we change the framework
import { getTraceId } from '$store/utils/traceId';
import { UserTypes } from '$types/UserTypes';

type ValidProperties = 'internalId' | 'role' | 'employerId';

type DefaultTrackingProps = {
  trace_id: string | null;
  employer_id?: number;
  internal_id?: number;
  type?: string;
  role?: string;
};

type IdentifyProps = {
  name: string;
  type: UserTypes;
  role: UserTypes;
  email?: string;
  CompanyName?: string;
  company_name?: string;
};

type ViewPageDataProps = {
  referrer: string;
  url: string;
};
/**
 * Wrapper for tracking events
 * @method emit Sends an event to the tracking framework
 * @method identify Sends an identification event to the tracking framework
 * @method viewPage Sends a view event to the tracking framework
 */

export const tracker = {
  /**
   * Triggers a track event
   * @param event Event name
   * @param properties JSON data that will be sent to the tracking framework
   * @param addProperties An array of properties that will automatically add the property and value to the payload
   */
  emit: (
    event: string,
    properties?: any,
    addProperties: ValidProperties[] = []
  ) => {
    return;
    const ServerUserFromLocalStorage = JSON.parse(
      localStorage.getItem('ServerUserResponse') || '{}'
    );
    const defaultProps: DefaultTrackingProps = {
      trace_id: getTraceId(),
    };

    addProperties.forEach((propName) => {
      if (propName === 'internalId') {
        defaultProps.internal_id = ServerUserFromLocalStorage?.Internal?.Id;
      }

      if (propName === 'role') {
        if (ServerUserFromLocalStorage.Candidate) {
          defaultProps.role = 'candidate';
          defaultProps.type = 'candidate';
        } else if (ServerUserFromLocalStorage.Employer) {
          defaultProps.type = 'employer';
          defaultProps.role = 'employer';
        } else if (ServerUserFromLocalStorage.Internal) {
          defaultProps.type = 'internal';
          defaultProps.role = 'internal';
        }
      }

      if (propName === 'employerId') {
        defaultProps.employer_id = ServerUserFromLocalStorage.Employer?.Id;
      }
    });
    // Observation: enable property override default props
    properties = { ...defaultProps, ...properties };
    window.analytics.track(event, properties);
  },
  /**
   * Triggers an identify event to tag the user
   * @param userId User id
   * @param options Any additional data to track the user
   * @returns {void}
   */
  identify: (userId: number, options: IdentifyProps) => {
    return;
    window.analytics.identify(userId.toString(), options);
  },
  /**
   * Triggers a view page event
   * @param viewPageData Any additional data to track the view page
   * @returns {void}
   */
  viewPage: (viewPageData: ViewPageDataProps) => {
    return;
    window.analytics.page(viewPageData);
  },
};
